var map = {
	"./1eshospital.png": 559,
	"./2research.jpg": 372,
	"./Bayan2.jpg": 560,
	"./Bayan_logo.png": 561,
	"./Bayan_logo1.png": 373,
	"./DR_bg.bmp": 562,
	"./DR_bg.svg": 563,
	"./DR_bg_clear.bmp": 564,
	"./Huda2.jpg": 565,
	"./Huda_logo.png": 566,
	"./Huda_logo1.png": 374,
	"./Kareem_logo1.jpg": 375,
	"./Kayan-Healthcare-Logo.svg": 567,
	"./NGI.png": 568,
	"./Prime.jpg": 569,
	"./Sama2.jpg": 570,
	"./Sama_logo.png": 571,
	"./Sama_logo1.png": 376,
	"./Sanad2.jpg": 572,
	"./Sanad_logo.png": 573,
	"./Sanad_logo1.png": 377,
	"./Sayan2.jpg": 574,
	"./Sayan_logo.png": 575,
	"./Sayan_logo1.png": 290,
	"./Soma.jpg": 378,
	"./Somod_logo.png": 576,
	"./Somod_logo1.png": 577,
	"./Tunbay.png": 578,
	"./aafiya.png": 579,
	"./aafiya2.png": 580,
	"./box.bmp": 581,
	"./box2-0.bmp": 582,
	"./dr1.svg": 583,
	"./eshospital.png": 584,
	"./fakeeh.jpg": 585,
	"./first.jpg": 586,
	"./health-insurance.jpg": 587,
	"./hospital.jpg": 588,
	"./img2.jpg": 379,
	"./kareem.jpg": 589,
	"./kayan-ceo.jpg": 380,
	"./kayan.PNG": 590,
	"./kayanLogo.jpg": 591,
	"./kayan_background.jpg": 592,
	"./kayan_no_bg.png": 593,
	"./linkedin.webp": 594,
	"./location.svg": 595,
	"./london.jpg": 596,
	"./market.jpg": 381,
	"./mohammed.jpg": 597,
	"./right.PNG": 598,
	"./scroll.webp": 382,
	"./sec_bg.png": 599,
	"./second.jpg": 600,
	"./service1.webp": 383,
	"./service2.webp": 384,
	"./service3.webp": 385,
	"./services.jpg": 386,
	"./teamCover.webp": 387,
	"./thumbay.jpg": 601,
	"./zulekha-hospital-logo.png": 602,
	"./zulekha.png": 603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 558;